module.exports = __webpack_public_path__ + "static/media/Euphoria.0dae180e.png";